import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  CardDeck,
  Col,
  Row,
  Table,
} from "reactstrap";
import React, { useContext, useEffect, useState } from "react";
import PageHeader from "../common/PageHeader";
import SectionCardHeader from "../common/SectionCardHeader";
import {
  fetchCurrentAccount,
  fetchReserveFund,
} from "../../helpers/api/finance";
import { isIterableArray } from "../../helpers/utils";
import { Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import NumberFormat from "react-number-format";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Or, PreloadState } from "../UI/preloading/PreloadState";
import {
  fetchProperties,
  findCondominiumMovements,
  findConfigAsProperty,
  findOneConfig,
} from "../../helpers/api/condominium";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import {
  faCashRegister,
  faExclamationTriangle,
  faPiggyBank,
} from "@fortawesome/free-solid-svg-icons";
import SupportLink from "../root/support/components/SupportLink";
import useSWRFetchPaginationProperty from "../../helpers/hooks/useSWRFetchPaginationProperty";
import { CurrencyContext } from "../../context/Context";

const Reserve = () => {
  const history = useHistory();

  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { role } = useSelector((state) => state.auth.user);

  const [aliquots, setAliquots] = useState(null);
  const [balance, setBalance] = useState(null);
  const [total, setTotal] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const [loadingAliquots, setLoadingAliquots] = useState(false);

  const [loadingBalance] = useState(false);
  const [loadingConfig, setloadingConfig] = useState(true);

  const [formDate, setformDate] = useState({
    since: null,
    to: null,
  });
  const [configSetted, setconfigSetted] = useState(false);
  // eslint-disable-next-line
  const [error, setError] = useState(null);
  const [params, setParams] = useState({
    condominiumId: role === "manager" ? selectedCondominium : null,
    start_date: null,
    end_date: null,
  });

  const [param, setParam] = useState({
    condominiumId: selectedCondominium,
    search: null,
  });

  const { currency: curr, baseCurrency } = useContext(CurrencyContext);
  const { currency } = useSelector((state) => state.auth);

  const {
    data: propertiesData,
    error: err,
    isLoading: propertiesIsLoading,
    meta: propertiesMeta,
    handler: {
      nextPage: propertiesNextPage,
      previousPage: propertiesPreviousPage,
      perPage: propertiesPerPage,
      goToPage: propertiesGoToPage,
    },
  } = useSWRFetchPaginationProperty(fetchProperties, param);

  const {
    data,
    isLoading,
    handler: { goToPage, nextPage, perPage, previousPage },
    meta,
  } = useSWRFetchPagination(findCondominiumMovements, params);

  const [reserve, setReserve] = useState(null);
  const [current, setCurrent] = useState(null);
  const [loadingReserve, setLoadingReserve] = useState(false);
  const [loadingCurrent, setLoadingCurrent] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const getReserve = async () => {
      setLoadingReserve(true);
      try {
        const { data } = await fetchReserveFund(1, 5, {
          condominiumId: selectedCondominium,
        });
        if (!!isMounted) setReserve(data);
      } catch (e) {
        isMounted && setError(e);
      } finally {
        isMounted && setLoadingReserve(false);
      }
    };
    getReserve();
  }, [selectedCondominium]);

  useEffect(() => {
    const isMounted = true;
    const getCurrent = async () => {
      setLoadingCurrent(true);
      try {
        const { data } = await fetchCurrentAccount(1, 5, {
          condominiumId: selectedCondominium,
        });
        if (isMounted) setCurrent(data);
      } catch (e) {
        isMounted && setError(e);
      } finally {
        isMounted && setLoadingCurrent(false);
      }
    };
    getCurrent();
  }, [selectedCondominium]);

  useEffect(() => {
    let isMounted = true;
    if (selectedCondominium) {
      if (role === "manager") {
        const getConfig = async () => {
          try {
            const { data } = await findOneConfig(selectedCondominium);
            if (isMounted)
              if (data.automatic !== null) {
                setconfigSetted(true);
              }
            setloadingConfig(false);
          } catch (error) {
            handleErrorMessage(error);
          }
        };
        getConfig();
      }
      if (role === "property") {
        const getConfig = async () => {
          try {
            const { data } = await findConfigAsProperty(selectedCondominium);
            if (isMounted) {
              if (data.automatic !== null) setconfigSetted(true);
              setloadingConfig(false);
            }
          } catch (error) {
            handleErrorMessage(error);
          }
        };
        getConfig();
      }
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [selectedCondominium]);

  const filteredData = data.map((item) => {
    try {
      const parsedDescription = JSON.parse(item.description);
      return { ...item, description: parsedDescription };
    } catch (error) {
      return item;
    }
  });

  const getDate = (date) => {
    var d = new Date(date);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  const handleSeeReserveFund = () => {
    if (selectedCondominium) {
      history.push(`/dashboard/funds/${selectedCondominium}/reserve`);
    }
  };

  const handleSeeCurrentFund = () => {
    if (selectedCondominium) {
      history.push(`/dashboard/funds/${selectedCondominium}/cash`);
    }
  };

  const days = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ];
  const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  return (
    <>
      <PageHeader
        title="Fondos de reserva"
        titleTag="h2"
        description={
          role === "manager"
            ? "Gestiona y administra cada uno de tus fondos."
            : "Visualiza las finanzas de tu condominio."
        }
        className="mb-3"
        col={{ lg: 9 }}
      >
        {role === "manager" && <SupportLink />}
      </PageHeader>
      <PreloadState cond={configSetted} loading={loadingConfig}>
        <Or value={true} cond={"manager"}>
          <CardDeck value={role} className="mb-2">
            <Card>
              <SectionCardHeader
                icon={faCashRegister}
                title="Caja"
                description="El dinero disponible del condominio y sus movimientos."
                action={{
                  label: "Ver caja",
                  onClick: handleSeeCurrentFund,
                  disabled: loadingAliquots,
                }}
              />
              <CardBody className="fs--1 p-0">
                <PreloadState
                  cond={isIterableArray(data)}
                  loading={loadingAliquots}
                >
                  <Or value={true}>
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Fecha</th>
                          <th>Proveedor o propietario</th>
                          <th>Descripción</th>
                          <th>Tipo</th>
                          <th>Monto</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData?.map(
                          (movement, i) =>
                            i < 5 && (
                              <tr key={movement.id}>
                                <td>{getDate(movement.created_at)}</td>
                                <td>
                                  {movement?.property !== null ? (
                                    <p>
                                      {
                                        movement?.property?.user?.data
                                          ?.firstname
                                      }{" "}
                                      {movement?.property?.user?.data?.lastname}
                                    </p>
                                  ) : movement?.provider !== null ? (
                                    <p>{movement?.provider}</p>
                                  ) : (
                                    <p>N/A</p>
                                  )}
                                </td>
                                <td>
                                  {" "}
                                  {movement.description.message
                                    ? movement.description.message
                                    : movement.description}
                                </td>
                                <td>
                                  {movement.isDecrement === 0 ? (
                                    <Badge className="rounded-capsule badge-soft-success">
                                      Ingreso
                                      <FontAwesomeIcon
                                        className="ml-2 "
                                        icon="fa-solid fa-arrow-up"
                                      />
                                    </Badge>
                                  ) : (
                                    <Badge className="rounded-capsule badge-soft-warning">
                                      Egreso
                                      <FontAwesomeIcon
                                        className="ml-2"
                                        icon="fa-solid fa-arrow-down"
                                      />
                                    </Badge>
                                  )}
                                </td>
                                <td>
                                  {" "}
                                  <Row>
                                    <Col>
                                      {" "}
                                      <NumberFormat
                                        className="text-right"
                                        displayType="text"
                                        allowedDecimalSeparators={true}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        prefix={`${baseCurrency.symbol} `}
                                        value={movement.amount}
                                      />
                                      <NumberFormat
                                        className="text-right"
                                        displayType="text"
                                        allowedDecimalSeparators={true}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        prefix={
                                          " | " + curr?.currency?.iso + " "
                                        }
                                        value={
                                          movement.amount *
                                          Number(curr?.value || 0)
                                        }
                                      />
                                    </Col>
                                  </Row>
                                </td>
                              </tr>
                            )
                        )}
                      </tbody>
                    </Table>
                  </Or>
                  <Or value={false}>
                    <Row className="p-card">
                      <Col>
                        <Alert color="info" className="mb-0">
                          Al parecer aún no hay movimientos para mostrar.
                        </Alert>
                      </Col>
                    </Row>
                  </Or>
                </PreloadState>
              </CardBody>
            </Card>
          </CardDeck>
          <CardDeck value={role} className="mb-2">
            <Card>
              <SectionCardHeader
                icon={faPiggyBank}
                color="success"
                title="Fondos de reserva"
                description="El saldo de cada fondo de reserva del condominio."
                action={{
                  label: "Ver fondos",
                  onClick: handleSeeReserveFund,
                  disabled: loadingAliquots,
                }}
              />
              <CardBody className="fs--1 p-0">
                {reserve && reserve.length > 0 ? (
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th>Descripción</th>
                        {/*            <th className="text-left">Periodo</th> */}
                        <th className="text-right">Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reserve.map(
                        (fund, i) =>
                          i < 5 && (
                            <tr key={i}>
                              <td className="text-left">
                                <Link
                                  to={{
                                    pathname: `/dashboard/finance/${selectedCondominium}/reserve-funds`,
                                  }}
                                >
                                  {fund.name}
                                </Link>
                              </td>
                              <td width="250">{fund.description}</td>
                              {/*                  <td className="text-left">{fund.name}</td> */}
                              <td className="text-right">
                                <NumberFormat
                                  prefix={`${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  thousandSeparator={true}
                                  displayType="text"
                                  value={fund.balance}
                                />
                                <NumberFormat
                                  displayType="text"
                                  prefix={" | " + curr?.currency?.iso + " "}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={fund.balance * Number(curr?.value || 0)}
                                />
                              </td>
                            </tr>
                          )
                      )}
                    </tbody>
                  </Table>
                ) : (
                  <Row className="p-card">
                    <Col>
                      <Alert color="info" className="mb-0">
                        Al parecer aún no hay fondos para mostrar. Puedes crear
                        una ahora mismo pulsando el siguiente enlace
                        <Button
                          data-testid="Button"
                          tag={Link}
                          color="link"
                          size="sm"
                          className="ml-1 pl-0"
                          to={`/dashboard/finance/${selectedCondominium}/reserve-funds/create`}
                        >
                          Crear fondo de reserva
                        </Button>
                      </Alert>
                    </Col>
                  </Row>
                )}
              </CardBody>
            </Card>
          </CardDeck>
          {/*           <CardDeck value={role} className="mb-2">
            <Card>
              <Button
                color="falcon-default"
                className="p-0"
                disabled={loadingAliquots}
                onClick={handleSeeCurrentFund}
              >
                <FalconCardHeader
                  title="Fondos por depositos de areas comunes"
                  subtitle={"Presiona para gestionar"}
                />
              </Button>
              <CardBody className="fs--1 p-0">
                <PreloadState
                  cond={isIterableArray(aliquots)}
                  loading={loadingAliquots}
                >
                  <Or value={true}>
                    <Table responsive={true}>
                      <thead>
                        <tr>
                          <th>Propietario</th>
                          <th>Descripción</th>
                          <th className="text-right">Monto</th>
                        </tr>
                      </thead>
                      <tbody>
                        {aliquots?.map(
                          (aliquot, i) =>
                            i < 5 && (
                              <tr key={i}>
                                <th scope="row">
                                  <Link
                                    to={`/dashboard/finance/${selectedCondominium}/aliquots/edit/${aliquot.id}`}
                                  >
                                    {aliquot.property.user.data.firstname}{" "}
                                    {aliquot.property.user.data.lastname}
                                  </Link>
                                </th>
                                <td>{aliquot.description}</td>
                                <td className="text-right">
                                  <NumberFormat
                                    allowedDecimalSeparators={true}
                                    prefix={`${baseCurrency.symbol} `}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    thousandSeparator={true}
                                    displayType="text"
                                    value={aliquot.value}
                                  />
                                </td>
                              </tr>
                            )
                        )}
                      </tbody>
                    </Table>
                  </Or>
                  <Or value={false}>
                    <Row className="p-card">
                      <Col>
                        <Alert color="info" className="mb-0">
                          Al parecer aún no hay alícuotas para mostrar. Puedes
                          crear una ahora mismo pulsando el siguiente enlace
                          <Button
                            data-testid="Button"
                            tag={Link}
                            color="link"
                            size="sm"
                            className="ml-1 pl-0"
                            to={`/dashboard/finance/${selectedCondominium}/reserve-funds/create`}
                          >
                            Crear fondo por depositos de areas comunes.
                          </Button>
                        </Alert>
                      </Col>
                    </Row>
                  </Or>
                </PreloadState>
              </CardBody>
            </Card>
          </CardDeck> */}
        </Or>
        <Or value={false} cond={"manager"}>
          <Or value={role}>
            <Alert color="warning" className="shadow-sm">
              <Row>
                <Col
                  xs="auto"
                  className="d-flex justify-content-center align-items-center"
                >
                  <FontAwesomeIcon icon={faExclamationTriangle} size={"lg"} />
                </Col>
                <Col className="d-flex justify-content-cente flex-column">
                  <h4 className="alert-heading">
                    ¡Configuración de días de cobro del condominio necesaria!
                  </h4>
                  <p className="mb-0">
                    Para poder acceder a las finanzas del condominio se necesita
                    configurar los días de cobro, para ello puedes acceder dando
                    click{" "}
                    <strong>
                      <Link to="/dashboard/config">aquí</Link>
                    </strong>
                    .
                  </p>
                </Col>
              </Row>
            </Alert>
          </Or>
        </Or>
      </PreloadState>
    </>
  );
};

export default Reserve;
